import { useAuthStore } from '@/core/stores/useAuthStore';
import { refreshSession } from './refresh';

/**
 * Decode JWT payload without verification (browser-side, just for exp check).
 */
function decodeJwtExp(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]));
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
}

function isTokenExpired(token: string, marginSec = 30): boolean {
  const exp = decodeJwtExp(token);
  if (exp === null) return true;
  return Date.now() / 1000 >= exp - marginSec;
}

/**
 * Get a valid (non-expired) token for WebSocket connections.
 * If the current token is expired, attempts a refresh through the shared
 * refresh lock (same one client.ts uses), so HTTP and WS never race the
 * server with the same refresh_token.
 *
 * Returns null if no valid token is available — caller must stop reconnecting.
 */
export async function getValidWsToken(): Promise<string | null> {
  const token = useAuthStore.getState().token;
  if (!token) return null;
  if (!isTokenExpired(token)) return token;
  return refreshSession();
}
